import {
    AccountsAction,
    CustomerAction,
    DashboardAction,
    InventoryAction,
    RestaurantAction,
    UtilitiesAction,
} from "../contants/Modules.Action.Type";

//INVENTORY ACTIONS

export const NewInventoryProduct = (Products) => (dispatch) => {
  dispatch({
    type: InventoryAction.SET_INVENTORY_PRODUCTS,
    payload: { Products },
  });
};
export const NewInventoryCategory = (Category) => (dispatch) => {
  dispatch({
    type: InventoryAction.SET_INVENTORY_CATEGORY,
    payload: { Category },
  });
};

export const NewInventoryIngredient = (Ingredient) => (dispatch) => {
    dispatch({
        type: InventoryAction.SET_INVENTORY_PRODUCT_INGREDIENT,
        payload: { Ingredient },
    });
};
export const NewInventoryGodown = (Godown) => (dispatch) => {
  dispatch({ type: InventoryAction.SET_INVENTORY_GODOWN, payload: { Godown } });
};
export const NewInventoryBrands = (Brand) => (dispatch) => {
  dispatch({ type: InventoryAction.SET_INVENTORY_BRANDS, payload: { Brand } });
};

// UTILITIES ACTION
export const UtilitiesEmployee = (Employee) => (dispatch) => {
  dispatch({
    type: UtilitiesAction.SET_UTILITIES_EMPLOYEE,
    payload: { Employee },
  });
};
export const UtilitiesUsers = (Users) => (dispatch) => {
  dispatch({ type: UtilitiesAction.SET_UTILITIES_USERS, payload: { Users } });
};
export const UtilitiesRoles = (Roles) => (dispatch) => {
  dispatch({ type: UtilitiesAction.SET_UTILITIES_USERS, payload: { Roles } });
};

export const RestaurantTableList = (TableList) => (dispatch) => {
  dispatch({
    type: RestaurantAction.SET_NEW_TABLE_LIST,
    payload: { TableList },
  });
};
export const RestaurantTableGroup = (TableGroup) => (dispatch) => {
  dispatch({
    type: RestaurantAction.SET_NEW_TABLE_GROUP,
    payload: { TableGroup },
  });
};

export const CustomerCustomersList = (CustomerList) => (dispatch) => {
  dispatch({
    type: CustomerAction.SET_CUSTOMER_LIST,
    payload: { CustomerList },
  });
};
export const CustomerMembership = (Membership) => (dispatch) => {
  dispatch({
    type: CustomerAction.SET_MEMBERSHIP,
    payload: { Membership },
  });
};

export const CustomerDiscountGroup = (Discount) => (dispatch) => {
  dispatch({ type: CustomerAction.SET_DISCOUNT, payload: { Discount } });
};

export const CustomerPromo = (Promo) => (dispatch) => {
  dispatch({ type: CustomerAction.SET_PROMOCODE, payload: { Promo } });
};

export const AccountHeads = (AccountHead) => (dispatch) => {
  dispatch({ type: AccountsAction.SET_ACCOUNT_HEAD, payload: { AccountHead } });
};

export const AccountGroups = (AccountGroup) => (dispatch) => {
  dispatch({
    type: AccountsAction.SET_ACCOUNT_GROUP,
    payload: { AccountGroup },
  });
};
export const GroupCategories = (GroupCategory) => (dispatch) => {
  dispatch({
    type: AccountsAction.SET_GROUP_CATEGORY,
    payload: { GroupCategory },
  });
};

export const PartyRates = (PartyRate) => (dispatch) => {
  dispatch({
    type: AccountsAction.SET_PARTY_RATE,
    payload: { PartyRate },
  });
};

export const setOdersummary = (orderSummary) => (dispatch) => {
  dispatch({
    type: DashboardAction.SET_ORDER_SUMMARY,
    payload: { orderSummary },
  });
};

export const setStatistics = (statistics) => (dispatch) => {
  dispatch({
    type: DashboardAction.SET_STATISTICS,
    payload: { statistics },
  });
};

export const setTodayInfo = (todayInfo) => (dispatch) => {
  dispatch({
    type: DashboardAction.SET_TODAYINFO,
    payload: { todayInfo },
  });
};

export const setTransactions = (transactions) => (dispatch) => {
  dispatch({
    type: DashboardAction.SET_TRANSACTIONS,
    payload: { transactions },
  });
};

export const setStockUpdate = (stockUpdate) => (dispatch) => {
  dispatch({
    type: DashboardAction.SET_STOCK_UPDATE,
    payload: { stockUpdate },
  });
};
